import { theme } from 'lib';
import styled from 'styled-components';

const StyledBadge = styled.div`
  height: 12px;
  width: 12px;
  border-radius: 12px;
  background-color: ${theme.SECONDARY};
  z-index: 1;

  ${(props) =>
    props.absolute &&
    `
    position: absolute;
    top: -2px;
    right: -2px;
  `}

  ${(props) => props.rightDistance && `right: ${props.rightDistance};`};
`;

export default StyledBadge;
